<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-action">
      <div class="button button-submit">
        <button class="btn" type="submit" name="note_order_settings"
          @click="action"
        >決定
        </button>
      </div>
      <div class="button button-close">
        <button class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span class="popup-title-main">ノートの複製</span>
        </div>
        <div class="popup-content">
          <p class="txt">ノートを複製してもよろしいですか？</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { NoteCopyConfirm } from '@/logic/note/NoteCopyConfirm'

export default defineComponent({
  name: 'SPNoteCopyConfirm',
  setup (props, context) {
    return {
      ...NoteCopyConfirm(props, context)
    }
  }
})
</script>

<style lang="scss" scoped>
.popup {
  &-content {
    padding: 20px;
  }
}
</style>
